import { motion } from 'framer-motion';
import React from 'react';

import Card from '../../../components/Card';
import Section from '../../../components/Section';
import { education } from '../../../constants';
import { DivStyleWidth, FlexContainerGrid } from '../../../styles/pages/Home';
import theme from '../../../styles/theme';
import { fadeInUp } from '../../../variants';

const Education: React.FC = () => {
    return (
        <Section backgroundColor={theme.colors.background}>
            <div className='container' >
                <motion.h1 variants={fadeInUp} >Formação</motion.h1>
                <motion.span variants={fadeInUp} className="sub-title">Educação</motion.span>
                <DivStyleWidth>
                    <FlexContainerGrid >
                        {education.map((item, index) => (
                            <Card
                                description={item.description}
                                name={item.name}
                                date={item.date}
                                key={index}
                            />
                        ))}
                    </FlexContainerGrid>
                </DivStyleWidth>
            </div>
        </Section>
    );
}

export default Education;